const namespaced = true;

const state = {
  items: [],
  studentEmail: '',
  parentEmail: ''
};

const getters = {
  items: state => state.items,
  studentEmail: state => state.studentEmail,
  parentEmail: state => state.parentEmail
};

const mutations = {
  SET_ITEM: (state, payload) => (state.items = payload),
  SET_STUDENT_EMAIL: (state, payload) => (state.studentEmail = payload),
  SET_PARENT_EMAIL: (state, payload) => (state.parentEmail = payload)
};

const actions = {
  // async fetchList({ commit, rootGetters }, payload) {
  //   try {
  //     const defaultPageable = rootGetters['table/defaultPageable'];
  //     const sortBy = payload.sortBy?.[0] ? `${payload.sortBy?.[0]}|${payload.sortDesc?.[0] ? 'desc' : 'asc'}` : null;
  //     const params = {
  //       size: defaultPageable.limit,
  //       page: defaultPageable.currentPage - 1,
  //       search: defaultPageable.search,
  //       gender: payload.gender,
  //       status: payload.status,
  //       sortBy
  //     };

  //     let url = `/api/user/student`;
  //     if ((payload.status !== '' && typeof payload.status != 'undefined') || payload.gender) {
  //       url = url.concat(`/filter`);
  //     }

  //     const {
  //       data: { data }
  //     } = await window.axios.get(url, { params });
  //     const { content, totalPages, totalElements } = data;

  //     commit('SET_ITEM', content);
  //     commit('table/SET_DEFAULT_TOTAL_PAGES', totalPages, { root: true });
  //     commit('table/SET_DEFAULT_TOTAL_ELEMENTS', totalElements, { root: true });
  //   } catch (err) {
  //     throw err;
  //   }
  // },

  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user/student?search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  async fetchFilter(_, { gender, status, search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user/student/filter?gender=${gender ?? ''}&status=${status ?? ''}&search=${search ?? ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchParentByEmail({ commit }, email) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user/parent/validate-email`, {
        params: { email },
        transformResponse: [data => ({ ...JSON.parse(data), disableNotification: false })]
      });
      return data;
    } catch (err) {
      throw err;
    }
  },

  save({ rootGetters }, payload) {
    if (payload.lastName === null) {
      payload.lastName = '';
    }
    if (payload.postalCode === null) {
      payload.postalCode = '';
    }
    if (payload.phoneNumber === null) {
      payload.phoneNumber = '';
    }
    const fd = new FormData();
    Object.keys(payload).forEach(field => fd.append(field, payload[field]));
    fd.append('roleId', 5);
    fd.append('schoolId', rootGetters['Auth/currentSchool']);
    fd.delete('userId');
    if (!payload.image) fd.delete('image');
    return window.axios.post('/api/user/student', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  update({ rootGetters }, payload) {
    if (payload.lastName === null) {
      payload.lastName = '';
    }
    if (payload.postalCode === null) {
      payload.postalCode = '';
    }
    if (payload.phoneNumber === null) {
      payload.phoneNumber = '';
    }
    const fd = new FormData();
    Object.keys(payload).forEach(field => fd.append(field, payload[field]));
    fd.append('roleId', 5);
    fd.append('schoolId', rootGetters['Auth/currentSchool']);
    fd.delete('userId');
    if (!payload.image) fd.delete('image');
    return window.axios.put(`/api/user/student/${payload.userId}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  saveParent({ rootGetters }, payload) {
    if (payload.lastName === null) {
      payload.lastName = '';
    }
    if (payload.postalCode === null) {
      payload.postalCode = '';
    }
    if (payload.phoneNumber === null) {
      payload.phoneNumber = '';
    }
    const fd = new FormData();
    Object.keys(payload).forEach(field => fd.append(field, payload[field]));
    fd.append('roleId', 3);
    fd.append('schoolId', rootGetters['Auth/currentSchool']);
    if (!payload.image) fd.delete('image');
    return window.axios.post('/api/user/parent', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  updateParent({ rootGetters }, payload) {
    if (payload.lastName === null) {
      payload.lastName = '';
    }
    if (payload.postalCode === null) {
      payload.postalCode = '';
    }
    if (payload.phoneNumber === null) {
      payload.phoneNumber = '';
    }
    const fd = new FormData();
    Object.keys(payload).forEach(field => fd.append(field, payload[field]));
    fd.append('roleId', 3);
    fd.append('schoolId', rootGetters['Auth/currentSchool']);
    if (!payload.image) fd.delete('image');
    return window.axios.put(`/api/user/parent/${payload.userId}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  // eslint-disable-next-line no-unused-vars
  downloadTemplate({ commit }) {
    return window.axios.get(`/api/user/student/template`, { responseType: 'arraybuffer' });
  },

  // eslint-disable-next-line no-unused-vars
  importData({ commit }, payload) {
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    return window.axios.post(`/api/user/student/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/user/${payload.userId}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
